import React from 'react';

import { Collapse, Typography, Form } from 'antd';

import DownloadFolderProductSetting from './product/DownloadFolderProductSetting';
import DownloadFolderAssetSetting from './asset/DownloadFolderAssetSetting';
import DownloadFolderMemberSetting from './member/DownloadFolderMemberSetting';
import DownloadFolderQuerySetting from './query/DownloadFolderQuerySetting';
import DownloadFolderReportingSetting from './reporting/DownloadFolderReportingSetting';

import { useFolderDownloadSettingQuery } from 'hooks/folders/queries';

const { Panel } = Collapse;

const itemSettings = [
  {
    fieldName: 'productCount',
    title: 'Product Hierarchy',
    component: DownloadFolderProductSetting,
  },
  {
    fieldName: 'assetCount',
    title: 'Digital Assets',
    component: DownloadFolderAssetSetting,
  },
  {
    fieldName: 'memberCount',
    title: 'Members',
    component: DownloadFolderMemberSetting,
  },
  {
    fieldName: 'queryCount',
    title: 'Queries',
    component: DownloadFolderQuerySetting,
  },
  {
    fieldName: 'reportingCount',
    title: 'Reports',
    component: DownloadFolderReportingSetting,
  },
];

const { Text } = Typography;

const DownloadFolderItemsSetting = () => {
  const form = Form.useFormInstance();
  const folderId = Form.useWatch('folderId', form);

  const { data: latestDownloadSetting } = useFolderDownloadSettingQuery({
    folderId,
    enabled: false,
  });

  return (
    <Collapse
      // expandIconPosition='right'
      ghost
    >
      {itemSettings.map((itemSetting) => {
        const itemCount = latestDownloadSetting?.[itemSetting?.fieldName];
        const ItemSetting = itemSetting.component;

        return itemCount ? (
          <Panel
            header={
              <Text
                style={{ fontWeight: 'bold' }}
              >{`${itemSetting.title} (${itemCount})`}</Text>
            }
            key={itemSetting?.fieldName}
            forceRender
          >
            <ItemSetting />
          </Panel>
        ) : null;
      })}
    </Collapse>
  );
};

export default DownloadFolderItemsSetting;
